(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row-result/assets/javascripts/animations/result.js') >= 0) return;  svs.modules.push('/components/tur/ball-row-result/assets/javascripts/animations/result.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.result = svs.tur.ball.row.result || {};
svs.tur.ball.row.result.animations = svs.tur.ball.row.result.animations || {};
const Events = svs.tur.ball.constants;
const BALLS_TO_SPIN = 9;
class Result {
  _addFauxNumbers(correctNumber, fromArray) {
    fromArray.unshift(correctNumber);
    return fromArray.map(number => "".concat(number, "\n")).join('');
  }
  spin(ball) {
    let speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    const tl = gsap.timeline({
      onStart: () => {
        ball.$number.innerText = this._addFauxNumbers(ball.number, svs.tur.ball.helpers.generateArraySpinNumbers(BALLS_TO_SPIN, ball.min, ball.max, ball.number));
      },
      onComplete: () => {
        ball.setNumber(ball.number);
        ball.trigger(Events.BALL_RESULT_REVEALED, ball);
      }
    });
    const textColor = getComputedStyle(ball.$el).color;
    const textShadowStr = "0 0 4px ".concat(textColor, ", 0 -15px 3px ").concat(textColor, ", 0 -25px 6px ").concat(textColor);
    const spinRepeat = speed <= 1 ? 0 : Math.floor(speed);
    tl.set(ball.$number, {
      y: "".concat(-((BALLS_TO_SPIN - 1) * 100), "%"),
      textShadow: textShadowStr,
      opacity: 0.7
    });
    tl.set(ball.$inner, {
      opacity: 0
    });
    tl.to(ball.$number, {
      keyframes: [{
        duration: speed,
        y: "-100%",
        repeat: spinRepeat,
        ease: 'none'
      }, {
        duration: 1,
        ease: 'back.out(3)',
        y: 0
      }, {
        duration: 0.3,
        textShadow: 'none',
        delay: -1.3,
        opacity: 1
      }]
    });
    tl.to(ball.$inner, {
      duration: 0.2,
      opacity: 1
    }, '<.1');
    tl.to(ball.$el, {
      duration: 0.2,
      scale: 1.2,
      ease: 'back.out(3)'
    }, '-=.3');
    tl.to(ball.$el, {
      duration: 0.2,
      scale: 1,
      ease: 'back.out(3)'
    });
    return tl;
  }
}
svs.tur.ball.row.result.animations.Result = new Result();

 })(window);